import { useLocation } from 'react-router-dom'

export const useDefaultBackHref = (defaultPath?: string) => {
  const { state } = useLocation()
  return state?.from ?? defaultPath
}
